import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { ModuleWrapper, ModuleWrapperProps } from '@access-erp/common';
import React, { JSX } from 'react';

import { ApolloClientProvider } from './providers/ApolloClientProvider';
import { ConfigurationProvider } from './providers/ConfigurationProvider';

export const EnquiriesApplicationModule = <TPages,>({
  children,
  ...props
}: ModuleWrapperProps<TPages> & { apolloClient: ApolloClient<NormalizedCacheObject>, 
  gridContainerStyle?: React.CSSProperties }): JSX.Element => (
  <ModuleWrapper {...props}>
    <ApolloClientProvider apolloClient={props.apolloClient}>
      <ConfigurationProvider>
        <div style={{ 
          height: props.gridContainerStyle?.height 
          ?? 'calc(100vh - 40px)', ...props.gridContainerStyle }}>{children}</div>
      </ConfigurationProvider>
    </ApolloClientProvider>
  </ModuleWrapper>
  );
